<template>
  <div>
    <div class="position-relative">
      <b-card>
        <div slot="header">ایجاد</div>
        <parentChildForm
          v-for="(item, index) in $v.items.$each.$iter"
          :key="index"
          :item="item"
          :item_index="index"
          :relationship_options="relationship_options"
        />
      </b-card>
    </div>
    <div>
      <b-button variant="success" @click="save">
        {{ $lang.submitButton }}
        <i class="fa fa-check"></i>
      </b-button>
      <b-button
        type="reset"
        class="ml-2"
        size="md"
        variant="danger"
        @click="closeModal"
      >
        {{ $lang.cancelButton }}
        <i class="fa fa-ban"></i>
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import parentChildForm from "./parentChildForm";
export default {
  validations: {
    items: {
      $each: {
        name: {
          required,
        },
        family: {
          required,
        },
        mobile: {
          required,
          numeric,
          minLength: minLength(11),
          maxLength: maxLength(11),
        },
        national_code: {
          required,
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(10),
        },
        location_selected: {
          required,
        },
        birth_date: {
          required,
        },
        relationship_with_you: {
          required,
        },
        regional_municipality: {},
        address: {},
      },
    },
  },
  props: {
    serviesUse: {
      type: String,
      default: "",
    },

    itemId: {
      type: [String, Number],
    },
    code: {
      type: String,
    },
    modalNewColumn: {
      type: Boolean,
      default: false,
    },
    //   work_type_options: {
    //     type: Array,
    //   },
    relationship_options: {
      type: Array,
    },
    //   genderLoading: {
    //     type: Boolean,
    //     default: false
    //   },
  },
  components: {
    parentChildForm,
  },
  data() {
    return {
      items: [
        {
          name: null,
          family: null,
          mobile: null,
          national_code: null,
          location_selected: null,
          birth_date: null,
          relationship_with_you: null,
          regional_municipality: null,
          address: null,
        },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    async save() {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }

      let resItems = [];
      let personRelat = false;
      if (this.items.filter((x) => x.national_code).length > 0) {
        this.items.map((x) => {
          let payload = {
            name: x.name,
            family: x.family,
            mobile: x.mobile,
            email: x.email,
            national_code: x.national_code,
            meta_data: {
              address: x.address,
              birth_date: x.birth_date,
              relationship_with_you:
                x.relationship_with_you && x.relationship_with_you.value,
              // location_selected: x.location_selected
            },
            gender_id: x.gender_selected && x.gender_selected.value,
            zone_number: x.regional_municipality,
            location_id: x.location_selected && x.location_selected.id,
            relation_type_id: this.$config.relation_type.parentChildForm,
            // related_location_type: "place",
            // related_location_id: x.location_selected && x.location_selected.id
          };
          let id = x.code ? x.code : null;
          // Promise.all([])

          personRelat = null;
          if (this.serviesUse) {
            personRelat = this.putPersonRelation(
              payload,
              this.code,
              this.serviesUse,
              id
            );
          } else {
            personRelat = this.putPersonRelation(payload, id);
          }
        });

        Promise.all([personRelat]).then((res) => {
          if (res.includes(true)) {
            this.$notify.success("عملیات موفقیت آمیز بود");
            this.closeModal();
            this.items = [
              {
                name: null,
                family: null,
                mobile: null,
                national_code: null,
                location_selected: null,
                birth_date: null,
                relationship_with_you: null,
                regional_municipality: null,
                address: null,
              },
            ];
          }
        });
      }
    },
  },
  created() {
    if (this.itemId) {
      this.findPersonRelation(this.code, this.itemId).then(() => {
        if (this.relations.length > 0) this.items = this.relations;
      });
    }
  },
};
</script>
